import { useEffect, useState } from 'react'
import {
  useApolloClient,
  ApolloQueryResult,
  QueryOptions,
  NetworkStatus
} from '@apollo/client'

/**
 * a hook that runs apollo query with a timeout to avoid hitting the server with unnecessary requests
 */
export const useDebouncedQuery = <TData, TVariables = any>(
  options: QueryOptions<TVariables>,
  delay: number
) => {
  const [queryState, setQueryState] = useState<
    ApolloQueryResult<TData> & { stale: boolean }
  >({
    loading: true,
    networkStatus: NetworkStatus.loading,
    errors: [],
    stale: false,
    data: undefined as any
  })
  const apolloClient = useApolloClient()

  useEffect(() => {
    const handler = setTimeout(() => {
      apolloClient.query(options).then(
        (state) => {
          // @ts-expect-error 9/11/2020
          setQueryState(state)
        },
        (error) => {
          setQueryState({ errors: error, ...queryState })
        }
      )
    }, delay)

    return () => {
      clearTimeout(handler)
    }
  }, [JSON.stringify(options), delay])

  return queryState
}
